var _path, _path2, _path3, _circle, _rect, _circle2, _circle3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBenfitsewing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: 480,
    height: 480,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6c19ff",
    d: "M37.929,40C38.561,38.792,39,37.569,39,36.818C39,31.396,32.284,27,24,27S9,31.396,9,36.818 c0,0.751,0.349,1.889,1.071,3.182H37.929z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5bc00",
    d: "M38.999,45H9l-0.001-8H39L38.999,45C39,45,39,45,38.999,45z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3dd9eb",
    d: "M22.666,31.732l-1.18-22.841l2.975-0.385l1.176,22.811l-1.145,2.903L22.666,31.732z M19.033,34.188 l0.283-3.108l-8.002-20.181l-2.747,1.205l8.014,20.209L19.033,34.188z M31.757,32.002l6.254-21.609l-2.833-0.986l-6.244,21.58 l0.526,3.076L31.757,32.002z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 7,
    r: 4,
    fill: "#f5bc00"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 3,
    x: 9,
    y: 37,
    fill: "#2100c4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 11,
    r: 4,
    fill: "#6c19ff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 10.5,
    r: 4,
    fill: "#f55376"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2100c4",
    d: "M31.757,32.002l0.921-3.183c-0.876-0.408-1.814-0.762-2.816-1.04l-0.928,3.208l0.526,3.076 L31.757,32.002z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#2100c4",
    d: "M22.424,27.055l0.242,4.677l1.826,2.488l1.145-2.903l-0.22-4.27C24.95,27.018,24.478,27,24,27 C23.468,27,22.942,27.02,22.424,27.055z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#2100c4",
    d: "M16.582,32.313l2.451,1.875l0.283-3.108l-1.294-3.264c-0.998,0.284-1.934,0.642-2.805,1.055 L16.582,32.313z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenfitsewing);
export default __webpack_public_path__ + "static/media/benfitsewing.944cd18c2af7a4c5ca62fc606fcb01d1.svg";
export { ForwardRef as ReactComponent };